import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import "../../../styles/Auth/combo.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import addIcon from '@iconify/icons-mdi/plus-circle-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import ComboOfferDetailsPopup from "./viewComboOffer.jsx";
import ComboOfferAssignPopup from "./comboOfferPopUp.jsx";

const ComboOfferPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddComboOffer = location.pathname === '/combooffers/add';
    const [products, setProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const containerRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [comboOffers, setcomboOffers] = useState([]);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editComboOfferId, setEditComboOfferId] = useState(null);
    const [ComboOffersToDelete, setComboOffersToDelete] = useState(null);
    const [viewComboOfferData, setViewComboOfferData] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [isAssignPopupOpen, setIsAssignPopupOpen] = useState(false);
    const [selectedOfferId, setSelectedOfferId] = useState(null);
    const [filters, setFilters] = useState({
        startDate: "",
        endDate: ""
    });

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };

    const headings = [
        'SL',
        'Offer Name',
        'Offer Type',
        'Products',
        'Offer Price (₹)',
        'Offer Start Date',
        'Offer End Date',
        'Action',
    ];

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const token = sessionStorage.getItem("sessionToken");
        const fetchProducts = async () => {
            try {
                const res = await getData("/products/products", {}, token);
                setProducts(res?.data?.[0]?.paginatedResults || []);
            } catch {
                setProducts([]);
            }
        };
        const fetchCategories = async () => {
            try {
                const res = await getData("/categories/categories", {}, token);
                setCategories(res?.data?.results?.[0].paginatedResults || []);
            } catch {
                setCategories([]);
            }
        };
        const fetchSubCategories = async () => {
            try {
                const res = await getData("/subcategories/subcategories", {}, token);
                setSubCategories(res?.data?.results?.[0].paginatedResults || []);
            } catch {
                setSubCategories([]);
            }
        }
        fetchProducts();
        fetchCategories();
        fetchSubCategories();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const [formData, setFormData] = useState({
        offerName: '',
        offerType: '',
        productIds: [],
        offerPrice: '',
        sellingPrice: '',
        offerStartDate: '',
        offerEndDate: '',
        // colors: []
    });

    useEffect(() => {
        if (formData.productIds.length === 0) {
            setFormData((prev) => ({ ...prev, offerPrice: "", colors: [] }));
            return;
        }

        // Get selected product details
        const selectedProducts = products.filter((p) =>
            formData.productIds.includes(p._id)
        );

        // Sum selling prices
        const totalSellingPrice = selectedProducts.reduce(
            (sum, product) => sum + (product.sellingPrice || 0),
            0
        );

        // Collect unique colors from attributes
        const uniqueColors = [
            ...new Set(
                selectedProducts.flatMap((p) =>
                    p.attributes?.flatMap((a) => a.values || []) || []
                )
            ),
        ];

        setFormData((prev) => ({
            ...prev,
            sellingPrice: totalSellingPrice.toFixed(2),
            colors: uniqueColors,
        }));
    }, [formData.productIds, products]);

    const handleAddcomboOffer = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const ComboOfferData = {
                ...formData
            };
            console.log("Sending ComboOffer data:", ComboOfferData);
            const response = await postData('comboOffers/', ComboOfferData, sessionToken);
            toast.success(response.message || 'Combo Offer added successfully');
            setFormData({
                offerName: '',
                offerType: '',
                productIds: [],
                offerStartDate: '',
                offerEndDate: '',
                sellingPrice: '',
                offerPrice: ''
            });
            navigate("/comboOffers");
            fetchComboOffers();
        } catch (error) {
            console.error('Add Combo Offer Error:', error);
            toast.error(error.message || 'Add Combo Offer Failed');
        }
    }

    const handleOpen = (comboOfferId) => {
        setComboOffersToDelete(comboOfferId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setComboOffersToDelete(null);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const fetchComboOffers = async (page, limit, searchQuery, filters = {}) => {
        const params = {
            page,
            limit,
            offerName: searchQuery?.trim() || "",
            offerType: searchQuery?.trim() || "",
        }
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        try {
            setLoading(true);
            const response = await getData('combooffers/combooffers', params, sessionToken);
            const resultsWrapper = response?.data?.[0] || [];
            const ComboOffersList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setcomboOffers(ComboOffersList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Combo Offers");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchComboOffers(currentPage, limit, searchQuery, filters);
    }, [currentPage, limit, refreshKey, searchQuery, filters]);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleViewComboOffer = async (comboOfferId) => {
        try {
            setLoading(true);
            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");
            // Fetch data using your getData function
            const response = await getData(`comboOffers/comboOffer/${comboOfferId}`, sessionToken);
            // Check if response is already JSON
            const data = response?.data || response;
            // Set the view data
            setViewComboOfferData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Combo Offer:", error);
            toast.error(error.message || "Failed to fetch Combo Offer data");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteComboOffer = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`comboOffers/comboOffer/${ComboOffersToDelete}`, token);
            toast.success(response.message || "Combo Offer deleted successfully");
            setComboOffersToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Combo Offer");
        }
    }

    const handleOpenAssignPopup = (offerId) => {
        setSelectedOfferId(offerId);
        setIsAssignPopupOpen(true);
    };

    const handleUpdateCombo = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("sessionToken");
            const updatedComboData = { offerName: formData.offerName, offerType: formData.offerType, productIds: formData.productIds, offerPrice: formData.offerPrice, sellingPrice: formData.sellingPrice, offerStartDate: formData.offerStartDate, offerEndDate: formData.offerEndDate, };
            console.log("Updating Combo Offer with data:", updatedComboData);
            // API call — adjust the endpoint to your backend route 
            const response = await putData(`comboOffers/comboOffer/${editComboOfferId}`, updatedComboData, token);
            toast.success(response.message || 'Combo Offer updated successfully');
            // Reset form & close popup 
            setFormData({
                offerName: '',
                offerType: '',
                productIds: [],
                offerPrice: '',
                sellingPrice: '',
                offerStartDate: '',
                offerEndDate: '',
            });
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchComboOffers(currentPage, limit);
            triggerRefresh();
        }
        catch (error) {
            console.error("Error updating combo offer:", error);
            toast.error("Error updating combo offer.");
        }
    };

    return (
        <div className="comboOffer-layout">
            <div className="comboOffer-content">
                <main className="comboOffer-main">
                    {isAddComboOffer ? (
                        <div className="add-comboOffer-form">
                            <h3>Add Combo Offer</h3>
                            <form className="comboOffer-form">
                                <div className="comboOffer-form-row">
                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Offer Name</label>
                                        <input
                                            type="text"
                                            className="comboOffer-input"
                                            value={formData.offerName}
                                            onChange={(e) => setFormData({ ...formData, offerName: e.target.value })}
                                        />
                                    </div>
                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Offer Type</label>
                                        <select
                                            className="comboOffer-input"
                                            value={formData.offerType}
                                            onChange={(e) => setFormData({ ...formData, offerType: e.target.value })}
                                        >
                                            <option value="">Select Offer Type</option>

                                            <option value="FlatOffer">Flat Offer</option>
                                            <option value="Buy1Get1">Buy 1 Get 1</option>
                                            <option value="Buy2Get1">Buy 2 Get 1</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>

                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Offer Price</label>
                                        <input
                                            type="number"
                                            className="comboOffer-input"
                                            value={formData.offerPrice}
                                            onChange={(e) => setFormData({ ...formData, offerPrice: e.target.value })}
                                        />
                                    </div>
                                    {formData.offerType === "FlatOffer" && (
                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Flat Offer Quantity</label>
                                        <input
                                            type="number"
                                            className="comboOffer-input"
                                            value={formData.flatQuantity || ""}
                                            onChange={(e) => setFormData({ ...formData, flatQuantity: e.target.value })}
                                        />
                                    </div>
                                    )}
                                </div>
                                <div className="comboOffer-form-row">
                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Offer Start Date</label>
                                        <input
                                            type="date"
                                            className="comboOffer-input"
                                            value={formData.offerStartDate}
                                            onChange={(e) => setFormData({ ...formData, offerStartDate: e.target.value })}
                                        />
                                    </div>
                                    <div className="comboOffer-form-group">
                                        <label className="input-label">Offer End Date</label>
                                        <input
                                            type="date"
                                            className="comboOffer-input"
                                            value={formData.offerEndDate}
                                            onChange={(e) => setFormData({ ...formData, offerEndDate: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="comboOffer-buttons">
                                    <button type="submit" className="add-comboOffer-button" onClick={handleAddcomboOffer}>
                                        Add Combo Offer
                                    </button>
                                    <button className="cancel-comboOffer-button" onClick={() => navigate('/comboOffers')}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>

                    ) : (
                        <>
                            <div className="comboOffer-widgets">
                                <div className="comboOffer-widgets-header">
                                    <h3>Combo Offers</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="comboOffer-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="ComboOffer-filterDate">
                                    <div className="Start-Date"
                                        style={{
                                            display: " flex",
                                            padding: "10px",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <label>Start Date</label>
                                        <input
                                            type="date"
                                            id="startDate"
                                            className="combo-date-input"
                                            value={filters.startDate || ""}
                                            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>
                                    <div className="End-Date">
                                        <label>End Date</label>
                                        <input
                                            type="date"
                                            id="endDate"
                                            className="combo-date-input"
                                            value={filters.endDate || ""}
                                            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="Clear-button">
                                    <button type="clear-combo"
                                        style={{
                                            background: "#8d2629",
                                            color: "white",
                                            fontWeight: "600px",
                                            padding: "10px",
                                            border: "1px solid #e6cf80",
                                            borderRadius: "10px"
                                        }}
                                        onClick={() => setFilters("")}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="add-comboOffer-buttons">
                                    <button className="add-btn-comboOffer" onClick={() => navigate('/combooffers/add')}>+ Add comboOffer</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-comboOffer-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-comboOffer-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {comboOffers.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={9}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '20px',
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        No combo offers found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            comboOffers.map((comboOffer, index) => (
                                                <TableRow key={comboOffer._id}>
                                                    {/* SL */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>

                                                    {/* Offer Name */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{comboOffer.offerName}</Typography>
                                                    </TableCell>

                                                    {/* Offer Type */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{comboOffer.offerType}</Typography>
                                                    </TableCell>

                                                    {/* Products */}
                                                    <TableCell align="center">
                                                        <Typography
                                                            onClick={() => handleViewComboOffer(comboOffer._id)}
                                                            sx={{
                                                                fontSize: 14,
                                                                color: comboOffer.productDetails?.length ? '#333' : 'gray',
                                                                fontWeight: 600,
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                '&:hover': { textDecoration: 'underline', color: '#8D2629' }
                                                            }}
                                                        >
                                                            {comboOffer.productDetails?.length
                                                                ? `${comboOffer.productDetails.length} `
                                                                : 'No products'}
                                                        </Typography>
                                                    </TableCell>


                                                    {/* Selling Price */}
                                                    {/* <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            ₹{comboOffer.sellingPrice?.toLocaleString() || 0}
                                                        </Typography>
                                                    </TableCell> */}

                                                    {/* Offer Price */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            ₹{comboOffer.offerPrice?.toLocaleString() || 0}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* Offer Start Date */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {new Date(comboOffer.offerStartDate).toLocaleDateString('en-GB')}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* Offer End Date */}
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {new Date(comboOffer.offerEndDate).toLocaleDateString('en-GB')}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* Actions */}
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                gap: 3,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            {/* <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewComboOffer(comboOffer._id)} /> */}
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    offerName: comboOffer.offerName || '',
                                                                    offerType: comboOffer.offerType || '',
                                                                    offerPrice: comboOffer.offerPrice || '',
                                                                    offerStartDate: comboOffer.offerStartDate || '',
                                                                    offerEndDate: comboOffer.offerEndDate || '',
                                                                    productIds: comboOffer.productIds || [],
                                                                    sellingPrice: comboOffer.sellingPrice || '',
                                                                });
                                                                setEditComboOfferId(comboOffer._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon
                                                                icon={deleteIcon}
                                                                width={20}
                                                                height={20}
                                                                style={{ color: '#C10000', cursor: 'pointer' }}
                                                                onClick={() => handleOpen(comboOffer._id)}
                                                            />
                                                            <Icon
                                                                icon={addIcon}
                                                                width={20}
                                                                height={20}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleOpenAssignPopup(comboOffer._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                    <ComboOfferDetailsPopup
                                        isOpen={openViewPopup}
                                        onClose={() => setOpenViewPopup(false)}
                                        comboOfferData={viewComboOfferData}
                                    />
                                </Table>
                            </TableContainer>
                            <div className="supplier-bottom">
                                <div className="supplier-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="supplier-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="supplier-section spacer"></div>
                                <div className="supplier-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="combo-popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    offerName: "",
                                                    offerType: "",
                                                    productIds: [],
                                                    offerPrice: "",
                                                    sellingPrice: "",
                                                    offerStartDate: "",
                                                    offerEndDate: "",
                                                });
                                            }}
                                        />
                                        <div className="popup-form-combo">
                                            <div className="combo-popup-form">
                                                <h2 className="popup-title">
                                                    {isEditMode ? "Edit Combo Offer" : "Add Combo Offer"}
                                                </h2>
                                                <form className="popup-form-body" onSubmit={handleUpdateCombo}>
                                                    {/* Offer Name and Offer Type */}
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="offerName" className="input-label">
                                                                Offer Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="combo-input"
                                                                value={formData.offerName}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        offerName: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="offerType" className="input-label">
                                                                Offer Type
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="combo-input"
                                                                value={formData.offerType}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        offerType: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* Offer Price and Selling Price */}
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="offerPrice" className="input-label">
                                                                Offer Price
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="combo-input"
                                                                value={formData.offerPrice}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        offerPrice: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Offer Dates */}
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="offerStartDate" className="input-label">
                                                                Offer Start Date
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="combo-input"
                                                                value={
                                                                    formData.offerStartDate
                                                                        ? new Date(formData.offerStartDate).toISOString().split("T")[0]
                                                                        : ""
                                                                }
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        offerStartDate: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label htmlFor="offerEndDate" className="input-label">
                                                                Offer End Date
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="combo-input"
                                                                value={
                                                                    formData.offerEndDate
                                                                        ? new Date(formData.offerEndDate).toISOString().split("T")[0]
                                                                        : ""
                                                                }
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        offerEndDate: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Action Buttons */}
                                                    <div className="form-actions">
                                                        <button type="submit" className="btn-primary">
                                                            {isEditMode ? "Update Combo Offer" : "Add Combo Offer"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-secondary"
                                                            onClick={() => setIsPopupMode(false)}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Combo Offer?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: "#8D2629 " }} onClick={handleDeleteComboOffer}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )
                    }
                    <ComboOfferAssignPopup
                        isOpen={isAssignPopupOpen}
                        onClose={() => setIsAssignPopupOpen(false)}
                        products={products}
                        categories={categories}
                        subCategories={subCategories}
                        selectedOfferId={selectedOfferId}
                        fetchComboOffers={fetchComboOffers}
                        currentPage={currentPage}
                        limit={limit}
                    />
                </main>
            </div>

        </div >
    );
};

export default ComboOfferPage;